/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticheOperatoreStatsDTO { 
    /**
     * Budget totale disponibile dei bandi in scope (Σ budget_totale)
     */
    disponibilita_totale?: number;
    /**
     * Importo allocato alle richieste accettate: Σ degli importi redistribuiti delle righe finanziate delle graduatorie confermate
     */
    importo_totale_accettate?: number;
    /**
     * Valore totale emesso in voucher (Σ valore_totale)
     */
    importo_totale_vouchers?: number;
    /**
     * Valore residuo (non ancora speso) dei voucher (Σ valore_residuo)
     */
    importo_residuo_vouchers?: number;
    /**
     * Numero di voucher emessi (tutti gli stati tranne ANNULLATO)
     */
    richieste_voucher?: number;
    /**
     * Numero di voucher consegnati al cittadino (stati DA_CONSUMARE, PARZIALMENTE_CONSUMATO, CONSUMATO)
     */
    richieste_voucher_consegnati?: number;
}

